import { FileText } from "lucide-react"
import { useLocation } from "react-router-dom"
import { apiBaseUrl } from "@prescreen/lib/api-client"
import { useSession } from "../contexts/SessionContext"
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "./ui/tooltip"

export default function IntegratorDocsFab() {
  const { user, loading } = useSession()
  const location = useLocation()

  if (loading || !user) {
    return null
  }

  if (location.pathname.startsWith("/login")) {
    return null
  }

  if (location.pathname.startsWith("/prequalification")) {
    return null
  }

  const docsHref = `${apiBaseUrl}/api/docs`

  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <a
            href={docsHref}
            target="_blank"
            rel="noopener noreferrer"
            className="fixed bottom-6 right-6 z-50 flex h-12 w-12 items-center justify-center rounded-full bg-primary text-primary-foreground shadow-lg ring-offset-background transition-colors hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
            aria-label="Open Integrator API documentation (Swagger)"
          >
            <FileText className="size-5" aria-hidden />
          </a>
        </TooltipTrigger>
        <TooltipContent side="left" sideOffset={10}>
          Integrator API docs (Swagger)
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
